import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import RangeSelector from '../components/RangeSelector';

function renderSidebarContent(props) {
    const training = props.training
    const trainingType = props.trainingType

    if (props.orderType === 'voucher') {
        return <div className="offer-order">
            <h2 className="offer-order-title">Gutschein</h2>
            <dl className="offer-order-attr-list">
                <dt className="offer-order-attr-name">Betrag:</dt>
                <dd className="offer-order-attr-value">{props.voucherAmount.toFixed(2)} €</dd>
                <dt className="offer-order-attr-name">Name:</dt>
                <dd className="offer-order-attr-value">{props.voucherName}</dd>
                <dt className="offer-order-attr-name">Persönliche Nachricht:</dt>
                <dd className="offer-order-attr-value">{props.voucherText}</dd>
            </dl>
        </div>
    }

    if (!training) {
        return <div>
            <div className="text-center">
                <p>Wählen Sie im Kalender einen passenden Termin aus.</p>
            </div>
        </div>
    }

    return <div className="offer-order">
        <h2 className="offer-order-title">{trainingType.name}</h2>
        <dl className="offer-order-attr-list">
            <dt className="offer-order-attr-name">Datum:</dt>
            <dd className="offer-order-attr-value">{moment(training.date).format('D. MMMM YYYY')}</dd>
            <dt className="offer-order-attr-name">Beginn:</dt>
            <dd className="offer-order-attr-value">{training.startAt.substring(0,5)}</dd>
            <dt className="offer-order-attr-name">Ende:</dt>
            <dd className="offer-order-attr-value">{training.endAt.substring(0,5)}</dd>
            <dt className="offer-order-attr-name">Freie Plätze:</dt>
            <dd className="offer-order-attr-value">{training.freeSlots}</dd>
            <dt className="offer-order-attr-name">Teilnehmerzahl:</dt>
            <dd className="offer-order-attr-value">
                <RangeSelector
                    min={1}
                    max={training.slots-training.participants}
                    step={1}
                    value={props.participantCount}
                    onValueChange={(value) => props.onParticipantCountChanged(value)}
                    />
            </dd>
        </dl>
    </div>
}

function renderSidebarFooter(props) {
    let price = 0.00

    const training = props.training
    const trainingType = props.trainingType

    if (props.orderType === 'voucher') {
        return (
            <div>
                <table className="order-table" style={{width: '100%'}}>
                    <tbody>
                        <tr>
                            <td>Einzelposten</td>
                            <td style={{textAlign: 'right'}}>{(props.voucherAmount || 0).toFixed(2)} €</td>
                        </tr>
                        <tr>
                            <th style={{textAlign: 'left'}}>Zwischensumme:</th>
                            <td style={{textAlign: 'right'}}>{(props.voucherAmount || 0).toFixed(2)} €</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    <button
                        type="button"
                        className="btn"
                        onClick={props.prev}>
                        Zurück
                    </button>
                    {(
                    <button
                        className="btn right"
                        style={{float: 'right'}}
                        type={props.nextType}
                        onClick={props.next}
                        disabled={props.nextDisabled}
                    >
                        Weiter
                    </button>
                    )}
                </p>
            </div>
        )
    }

    if (props.training) {
        price = props.participantCount * training.price
    }

    return <div>
        <table className="order-table" style={{width: '100%'}}>
            <tbody>
                {props.training && [...Array(props.participantCount)].map((item, i) => (
                <tr key={i}>
                    <td>Teilnehmer {i+1}</td>
                    <td style={{textAlign: 'right'}}>{training.price.toFixed(2)} €</td>
                </tr>
                ))}
                <tr>
                    <th style={{textAlign: 'left'}}>Zwischensumme:</th>
                    <td style={{textAlign: 'right'}}>{price.toFixed(2)} €</td>
                </tr>
            </tbody>
        </table>
        <p>
            <button
                type="button"
                className="btn"
                onClick={props.prev}>
                Zurück
            </button>
            {(
            <button
                className="btn right"
                style={{float: 'right'}}
                type={props.nextType}
                onClick={props.next}
                disabled={props.nextDisabled}
            >
                Weiter
            </button>
            )}
        </p>
    </div>
}

const OrderOptionsComponent = (props) => {
    return (
        <div className="shop-sidebar-container">
            <header className="shop-sidebar-header">
                <h1 className="shop-sidebar-title">Auswahl</h1>
            </header>
            <div className="shop-sidebar-content">
                {renderSidebarContent(props)}
            </div>
            <footer className="shop-sidebar-footer">
                {renderSidebarFooter(props)}
            </footer>
        </div>
    )
}

export default connect(
    (state, props) => {
        return {
            participantCount: state.order.participants && state.order.participants.length,
            orderType: state.order.type,
            voucherAmount: state.order.voucherAmount,
            voucherText: state.order.voucherText,
            voucherName: state.order.voucherName
        }
    },
    (dispatch, props) => {
        return {
            onParticipantCountChanged: (participantCount) => {
                dispatch({type: 'ORDER_PARTICIPANT_COUNT_CHANGED', participantCount })
            }
        }
    }
)(OrderOptionsComponent)



// WEBPACK FOOTER //
// ./src/pages/OrderOptions.jsx